import BaseCtrl from 'edge/platform/base/BaseCtrl';
import BusinessConstant from 'customerEdge/policycommon/common/BusinessConstant';

const fn = ($scope, StateUtils, claimViewModel, InsuranceSuiteMetadata, ViewModelService, ModalService, TranslateService, ServiceBoxInfoService, $translate) => {
    const ctrl = Object.create(BaseCtrl);
    const flowModel = StateUtils.activeDataForState(true).flowModel;
    const warrantyCoverageCode = InsuranceSuiteMetadata.get('cc').types.getTypelist('CoverageType').getCode('zffjq03p8m2e00qmmu8s105hgg9').code;
    const maintenanceCoverageCode = InsuranceSuiteMetadata.get('cc').types.getTypelist('CoverageType').getCode('z5khi2u3qnqpcberbfaljcep4ea').code;
    const egvnWarrantyCoverageCode = InsuranceSuiteMetadata.get('cc').types.getTypelist('CoverageType').getCode('z8ajuarb3428tfs1oeecotrhag9').code;

    ctrl.init = function () {
        $scope.errorMsg = null;
        $scope.error = false;
        $scope.claimVm = ViewModelService.create(claimViewModel().value, 'cc', 'edge.capabilities.claim.fnol.dto.FnolDTO', { 'SubmittingClaim': true });
        const autoLossType = InsuranceSuiteMetadata.get('cc').types.getTypelist('LossType').getCode($scope.claimVm.lossType.value.code);
        const puwLOB = InsuranceSuiteMetadata.get('cc').types.getTypelist('LOBCode').getCode('PUWLine');
        $scope.LOSSCAUSE_DEFECT = BusinessConstant.LOSSCAUSE_DEFECT;
        $scope.LOSSCAUSE_MAINTENANCE = BusinessConstant.LOSSCAUSE_MAINTENANCE;
        //uncommented below code against defect UCWPRODENG-655
        //removed policy from below code against defect UCWPRODENG-660
        $scope.hasMaintenanceCov = false;
        if (Object.keys($scope.claimVm.value.lobs.puw_PSA.vehicles).length != 0) {
            $scope.hasMaintenanceCov = $scope.claimVm.value.lobs.puw_PSA.vehicles[0].coverages.find((item) => item.code_PSA === BusinessConstant.CC_COVERAGE_MAINTENANCE) != null;
        }
        $scope.filteredLossCauses = $scope.claimVm.lossCause.aspects.availableValues.filter((item) => {
            let maintCov = true;
            if (!$scope.hasMaintenanceCov && item.code === $scope.LOSSCAUSE_MAINTENANCE) {
                // LossCause.Maintenance available only for Policies with Maintenance coverage
                maintCov = false;
            }
            return maintCov && item.belongsToCategory(autoLossType) && item.belongsToCategory(puwLOB);
        });
        $scope.futureLossDateError = "";
        $scope.$watch('claimVm.lossCause.value', (newValue) => {
            if (newValue.code === $scope.LOSSCAUSE_MAINTENANCE) {
                $scope.claimVm.cause_PSA.value = null;
                $scope.claimVm.default_PSA.value = null;
                $scope.claimVm.maintenaceDone_PSA.value = null;
                $scope.claimVm.causeSubgroup_PSA.value = null;
                $scope.claimVm.defaultSubgroup_PSA.value = null;
            }
        });
        if ($scope.claimVm.serviceQuoteTempData != null && $scope.claimVm.serviceQuoteTempData.value != undefined) {
            ServiceBoxInfoService.serviceQuoteTempData = $scope.claimVm.serviceQuoteTempData.value;
        }

        $scope.disAgreeClicked = false;
        $scope.serviceBoxInfoPresent = false;
        if (ServiceBoxInfoService.serviceQuoteTempData != undefined &&
            ServiceBoxInfoService.serviceQuoteTempData.id != undefined) {
            $scope.isServiceBoxInfoPresent = true;
            $scope.claimVm.serviceBoxQuoteId = ServiceBoxInfoService.serviceQuoteTempData.id;

            $scope.totalAmount = ServiceBoxInfoService.serviceQuoteTempData.totalAmount;
            $scope.totalVAT = ServiceBoxInfoService.serviceQuoteTempData.totalVAT;
            $scope.totalTTC = ServiceBoxInfoService.serviceQuoteTempData.totalTTC;

            $scope.parts = ServiceBoxInfoService.serviceQuoteTempData.parts;
            $scope.partsTotalAmount = ServiceBoxInfoService.serviceQuoteTempData.partsTotalAmount;
            $scope.partsTotalDiscount = ServiceBoxInfoService.serviceQuoteTempData.partsTotalDiscount;
            $scope.partsTotalVAT = ServiceBoxInfoService.serviceQuoteTempData.partsTotalVAT;
            $scope.partsTotalTTC = ServiceBoxInfoService.serviceQuoteTempData.partsTotalTTC;

            $scope.operations = ServiceBoxInfoService.serviceQuoteTempData.operations;
            $scope.operationsTotalAmount = ServiceBoxInfoService.serviceQuoteTempData.operationsTotalAmount;
            $scope.operationsTotalDiscount = ServiceBoxInfoService.serviceQuoteTempData.operationsTotalDiscount;
            $scope.operationsTotalVAT = ServiceBoxInfoService.serviceQuoteTempData.operationsTotalVAT;
            $scope.operationsTotalTTC = ServiceBoxInfoService.serviceQuoteTempData.operationsTotalTTC;
        }
    };



    ctrl.next = function (form) {
        $scope.errorMsg = null;
        $scope.error = false;
        $scope.effectiveDateWarranty;
        $scope.expirationDateDateWarranty;
        $scope.effectiveDateMaintenance;
        $scope.expirationDateDateMaintenance;
        $scope.totalMileageLimit;
        var coverage;
        if (Object.keys($scope.claimVm.value.lobs.puw_PSA.vehicles).length != 0) {
            $scope.claimVm.value.lobs.puw_PSA.vehicles[0].coverages.forEach(function (coverage) {
                if (warrantyCoverageCode != null && coverage.code_PSA == warrantyCoverageCode) {
                    $scope.effectiveDateWarranty = coverage.effectiveDate;
                    $scope.expirationDateDateWarranty = coverage.expirationDate;
                }
                if (maintenanceCoverageCode != null && coverage.code_PSA == maintenanceCoverageCode) {
                    $scope.effectiveDateMaintenance = coverage.effectiveDate;
                    $scope.expirationDateDateMaintenance = coverage.expirationDate;
                }
                if (egvnWarrantyCoverageCode != null && coverage.code_PSA == egvnWarrantyCoverageCode) {
                    $scope.totalMileageLimit = coverage.totalMileageLimit;
                }
            });
        }

        $scope.lossDate = $scope.claimVm.value.lossDate.toISOString();

        form.submitted = true;
        var currentDate = new Date();
        var lostDate = $scope.claimVm.lossDate.value;
        if (moment(lostDate).isAfter(currentDate)) {
            $scope.futureLossDateError = $translate.instant('fnol.common.directives.loss-date-input.Loss date cannot be in the future');
            return false;
        }
        else {
            $scope.futureLossDateError = "";
        }
        if (!form.valid) {
            return;
        }
        if ($scope.claimVm.value.lossCause == $scope.LOSSCAUSE_DEFECT) {
            if ($scope.lossDate > $scope.expirationDateDateWarranty) {
                $scope.error = true;
                $scope.errorMsg = $translate.instant('fnol.common.controllers.PUWClaimDetailsCtrl.Policy coverage is over');
                return;
            } else if ($scope.lossDate < $scope.effectiveDateWarranty) {
                if (!$scope.claimVm.value.isWaitingPeriod) {
                    $scope.error = true;
                    $scope.errorMsg = $translate.instant('fnol.common.controllers.PUWClaimDetailsCtrl.Policy has not started yet');
                    return;
                }
            }
        }

        if ($scope.claimVm.value.lossCause == $scope.LOSSCAUSE_MAINTENANCE) {
            if ($scope.lossDate < $scope.effectiveDateMaintenance) {
                $scope.error = true;
                $scope.errorMsg = $translate.instant('fnol.common.controllers.PUWClaimDetailsCtrl.Policy has not started yet');
                return;
            } else if ($scope.lossDate > $scope.expirationDateDateMaintenance) {
                $scope.error = true;
                $scope.errorMsg = $translate.instant('fnol.common.controllers.PUWClaimDetailsCtrl.Policy coverage is over');
                return;
            }
        }

        if ($scope.claimVm.value.vehicleMileage_PSA > $scope.totalMileageLimit) {
            $scope.error = true;
            $scope.errorMsg = $translate.instant('fnol.common.controllers.PUWClaimDetailsCtrl.EGVN total mileage limit error');
            return;
        }

        if ($scope.isServiceBoxInfoPresent && !$scope.disAgreeClicked) {
            ModalService.showWarning('platform.widgets.fileupload.templates.Include service box data',
                'platform.widgets.fileupload.templates.Do you want to include the service box information in claim?',
                undefined, 'platform.widgets.fileupload.templates.Agree').result
                .then(() => {
                    $scope.claimVm.serviceQuoteTempData = ServiceBoxInfoService.serviceQuoteTempData;
                    flowModel.next($scope.claimVm);
                });
            return;
        }

       flowModel.next($scope.claimVm);
    };

    ctrl.previous = function () {
        flowModel.previous($scope.claimVm);
    };
    ctrl.cancel = function () {
        flowModel.cancel($scope.claimVm);
    };
    ctrl.disagree = function (form) {
        $scope.disAgreeClicked = true;
        ctrl.next(form);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils', 'claimViewModel', 'InsuranceSuiteMetadata', 'ViewModelService', 'ModalService','TranslateService', 'ServiceBoxInfoService', '$translate'];

export default fn;
